import React from 'react';

const TimelineChallengeIcon = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.3"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <title>Timeline Challenge</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-577.000000, -1695.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Timeline-Challenge" transform="translate(0.000000, 792.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="file-alt-light" transform="translate(14.000000, 19.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M15.5614063,5.5193125 L14.836875,4.79478125 C14.4115313,4.36946875 13.7920938,4.2535 13.2608125,4.446875 L11.5538125,2.739875 C11.7472188,2.2086875 11.6312813,1.58921875 11.2059063,1.16384375 L10.481375,0.43965625 C9.89521875,-0.1465 8.9463125,-0.14659375 8.3600625,0.43965625 L5.1223125,3.67709375 C4.53746875,4.2619375 4.53746875,5.2135625 5.1223125,5.7984375 L5.8468125,6.5229375 C6.27221875,6.94834375 6.89159375,7.064375 7.422875,6.87084375 L7.7460625,7.19403125 L5.97909375,8.96028125 C5.2909375,8.27215625 4.35828125,8.35875 3.80728125,8.90978125 L0.43965625,12.278375 C-0.1465,12.8645313 -0.14659375,13.8134375 0.43965625,14.3996875 L1.601,15.561375 C2.1858125,16.1461875 3.13740625,16.1462187 3.7223125,15.561375 L7.09021875,12.19275 C7.63434375,11.6486875 7.73559375,10.7167813 7.03971875,10.0209062 L8.8066875,8.2546875 L9.12984375,8.57784375 C8.9364375,9.10903125 9.052375,9.7285 9.47778125,10.1539062 L10.2720625,10.9481875 C10.8184375,11.4945625 11.7074375,11.4945937 12.2538438,10.9481875 L15.5614063,7.640625 C16.1461875,7.05578125 16.1461875,6.10415625 15.5614063,5.5193125 Z M2.66234375,14.5013438 L2.6616875,14.5006875 L1.5,13.3390313 L4.86790625,9.9704375 L6.0295625,11.1320938 L2.66234375,14.5013438 Z M11.2629375,9.81775 L10.5384375,9.09325 L11.0007187,8.63096875 L7.36975,5 L6.9075,5.46225 L6.183,4.73775 L9.42078125,1.5 L10.1452813,2.2245 L9.61975,2.75 L13.2507188,6.38096875 L13.7762187,5.85546875 L14.5007188,6.57996875 L11.2629375,9.81775 L11.2629375,9.81775 Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineChallengeIcon;

